import { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function BookRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => {
      window.open(
        "https://book.zeniastay.com",
        "_blank",
        "noopener,noreferrer"
      );

      navigate("/", { replace: true });
    }, 1100);

    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-surface px-4">

      {/* 🔥 CARD */}
      <motion.div
        initial={{ opacity: 0, y: 20, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.35 }}
        className="
          w-full max-w-[420px]
          rounded-2xl
          border border-border-soft
          bg-bg-surface
          shadow-card
          p-6
        "
      >

        <div className="flex flex-col items-center text-center gap-5">

          {/* 🔥 ICON (clean, not dot) */}
          <motion.div
            initial={{ rotate: -10, opacity: 0 }}
            animate={{ rotate: 0, opacity: 1 }}
            transition={{ duration: 0.4 }}
            className="
              w-10 h-10 rounded-xl
              bg-bg-light
              flex items-center justify-center
              border border-border-soft
            "
          >
            ↗
          </motion.div>

          {/* 🔥 TEXT */}
          <div>
            <p className="text-sm font-semibold text-text-primary">
              Redirecting to booking
            </p>
            <p className="text-xs text-text-muted mt-1">
              Securely opening Zenia booking platform
            </p>
          </div>

          {/* 🔥 PROGRESS BAR (REAL FEEL) */}
          <div className="w-full h-[4px] rounded-full bg-bg-light overflow-hidden">
            <motion.div
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 1.1, ease: "easeOut" }}
              className="h-full bg-brand-primary"
            />
          </div>

        </div>

      </motion.div>

    </div>
  );
}